/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */

const tabs = () => {
  const tabsNav = document.querySelectorAll('.js-tabs li');
  const getNodeindex = elm => [...elm.parentNode.children].indexOf(elm);
  const tabsItems = document.querySelectorAll('.js-tabs-target li');
  const tabsContainer = document.querySelector('.js-tabs');

  tabsNav.forEach(tab => {
    tab.addEventListener(
      'click',
      event => {
        if (tab !== event.target) return;
        if (tab.classList.contains('is-active')) {
          tabsContainer.classList.toggle('is-active');
          tabsNav.forEach((item, index) => {
            if (item.classList.contains('is-active')) {
              item.style.order = 0;
            } else {
              item.style.order = index + 1;
            }
          });
        } else {
          tabsNav.forEach(item => {
            item.classList.remove('is-active');
          });
          tabsNav[getNodeindex(event.target)].classList.add('is-active');
          tabsItems.forEach(item => {
            item.classList.remove('is-active');
          });
          tabsItems[getNodeindex(event.target)].classList.add('is-active');
          tabsContainer.classList.remove('is-active');
        }
      },
      true,
    );
  });
};

export default tabs;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/tabs.js